import React from 'react';

const WorkbookContext = React.createContext({});
export default WorkbookContext;
